import {inject, Injectable} from "@angular/core";
import {MatDialog, MatDialogConfig, MatDialogRef} from "@angular/material/dialog";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {DialogBase} from "./dialog.base";
import {ComponentType} from "@angular/cdk/portal";
import {ConfirmDialog, ConfirmDialogData} from "./confirm-dialog";

@Injectable({providedIn: "root"})
export class DialogService {
    private readonly dialog = inject(MatDialog);

    open<T extends DialogBase<unknown, unknown>>(component: ComponentType<T>, config: MatDialogConfig<DialogData<T>>): MatDialogRef<T, DialogResult<T>> {
        return this.dialog.open<T, DialogData<T>, DialogResult<T>>(component, config);
    }

    confirm(data: ConfirmDialogData, config?: MatDialogConfig<ConfirmDialogData>): Observable<boolean> {
        return this.open(ConfirmDialog, {
            width: '600px',
            ...config,
            data,
        })
            .afterClosed()
            .pipe(map((confirmed) => confirmed === true));
    }
}

type DialogData<T> = T extends DialogBase<infer Data, unknown> ? Data : never;
type DialogResult<T> = T extends DialogBase<unknown, infer Result> ? Result : never;